export default __webpack_public_path__ + "static/media/button-help.2ab38504.svg";